import {Injectable} from '@angular/core';
import {CanActivate, Router, UrlTree} from '@angular/router';
import {Observable} from 'rxjs';
import {find} from 'lodash';
import {ILanguage, LANGUAGES} from '../services/language.service';
import {setLanguage} from '../store/actions/user.actions';
import {saveToLocalStorage} from '../store/actions/store.actions';
import {Store} from '@ngrx/store';
import {IAppState} from '../models/IAppState';
import {filter, map, take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class LanguageGuard implements CanActivate {
  private isAuthorised$: Observable<boolean> = this.store.select((state) => state.AppStateReducer.isAuthorised);

  private languages: ILanguage[] = LANGUAGES;

  constructor(
    private router: Router,
    private store: Store<{AppStateReducer: IAppState}>
  ) {
  }

  canActivate(): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const browserLang = navigator.language.split('-')[0];
    const foundLang = find(this.languages, {code: browserLang});

    return this.isAuthorised$.pipe(
      filter(val => val !== null),
      take(1),
      map((isAuthorised: boolean) => {
        if (isAuthorised) {
          this.router.navigate(['/reservations-list'], {replaceUrl: true});
        } else if (foundLang) {
          this.setLang(browserLang);
          this.router.navigate(['/login'], {replaceUrl: true});
        } else {
          return true;
        }
      })
    );
  }

  setLang(browserLang: string) {
    this.store.dispatch(setLanguage({language: browserLang}));
    this.store.dispatch(saveToLocalStorage());
  }
}
